module.exports = __webpack_public_path__ + "static/1_Colonize_2208x1242.0da7b287.0da7b287.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1_Colonize_2208x1242.0da7b287.png
// module id = 479
// module chunks = 114276838955818